import React from 'react';
import {JadrolinijaVehicleModelType} from "@CheckOrder/features/addons/features/jadrolinija/types/JadrolinijaVehicleModel.type";

type VehicleSuggestionProps = {
    suggestion: JadrolinijaVehicleModelType
    onClick?: () => void,
    onMouseDown?: () => void,
    onTouchStart?: () => void,
}
const VehicleSuggestion = ({suggestion, onClick, onMouseDown, onTouchStart}: VehicleSuggestionProps) => {
    const onClickHandler = (e: React.MouseEvent | React.TouchEvent) => {
        e.preventDefault()
        e.stopPropagation()
        if (onClick) {
            onClick()
        }
    }

    const handleMouseDown = (e: React.MouseEvent) => {
        if (onMouseDown) {
            onMouseDown()
        }
    }

    const handleTouchStart = (e: React.TouchEvent) => {
        if (onTouchStart) {
            onTouchStart()
        }
    }

    return (
        <div
            role="button"
            onClick={onClickHandler}
            onMouseDown={handleMouseDown}
            onTouchStart={handleTouchStart}
            className="suggestion-content"
        >
            <span>
                {suggestion.name}
            </span>
        </div>
    )
};

export default VehicleSuggestion;